import * as THREE from 'three';
import { CONFIG } from '../config.js';
import { Monster } from '../render/Monster.js';

const _pos = new THREE.Vector3();

/**
 * Monstruo verde que persigue al jugador. No tiene lógica propia: World decide a qué distancia va
 * (chaser.gap) y le da su posición sobre el recorrido que ha hecho el jugador.
 */
export class Chaser {
  constructor(scene) {
    this.model = new Monster();
    this.mesh = this.model.root;
    this.mesh.name = 'Chaser';
    scene.add(this.mesh);
  }

  update(world, dt) {
    const yaw = world.chaserPose(_pos);
    this.mesh.position.copy(_pos);
    this.mesh.rotation.y = yaw;
    // Fuera de cámara cuando va lejos; así no estorba en las curvas.
    this.mesh.visible = world.chaser.gap < CONFIG.chaser.farGap - 2;

    const p = world.player;
    const running = p.state === 'running' || p.state === 'idle';
    this.model.update(dt, running ? p.speed : 5, world.chaser.near > 0 || !running, p.state === 'caught');
  }
}
